module.exports = __webpack_public_path__ + "resources/icon_50_follow.27c13b130ee0f733.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_follow.png
// module id = 457
// module chunks = 0 1 2 3 4